enum QueryParams {
  partner = 'partner',
}

function checkForPartnerParam(params: URLSearchParams) {
  const partner = params.get('partner');
  if (partner) {
    localStorage.setItem(QueryParams.partner, partner);
  }
}

function getItem(param: keyof typeof QueryParams) {
  const p = localStorage.getItem(QueryParams[param]);
  return p;
}

function deleteItem(param: keyof typeof QueryParams) {
  localStorage.removeItem(QueryParams[param]);
}

function setItem(param: keyof typeof QueryParams, value: string) {
  localStorage.setItem(QueryParams[param], value);
}

async function start() {
  try {
    const params = new URLSearchParams(window.location.search);
    checkForPartnerParam(params);
    // add more param checks here
  } catch (err: any) {
    // noop
  }
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return {
    deleteItem,
    getItem,
    setItem,
    start,
  };
})();
